import * as Yup from 'yup'

export const validateOneLowercaseCharacter = (value: string | undefined) =>
  Yup.string()
    .required()
    .matches(/(?=.*[a-z])/)
    .isValidSync(value)

export const validateOneUppercaseCharacter = (value: string | undefined) =>
  Yup.string()
    .required()
    .matches(/(?=.*[A-Z])/)
    .isValidSync(value)

export const validateOneNumber = (value: string | undefined) =>
  Yup.string()
    .required()
    .matches(/(?=.*[0-9])/)
    .isValidSync(value)

export const validateOneSpecialCharacter = (value: string | undefined) =>
  Yup.string()
    .required()
    .matches(/(?=.*[!@#$%^&*(),.?":{}|<>])/)
    .isValidSync(value)

export const validateAtLeastNCharactersLong = (
  value: string | undefined,
  n: number
) => Yup.string().required().min(n).isValidSync(value)

export const validatePassword = (
  value: string | undefined,
  strongPassword: boolean | undefined
) => {
  const validations = [
    validateOneLowercaseCharacter(value),
    validateOneNumber(value),
    validateAtLeastNCharactersLong(value, strongPassword ? 12 : 8),
  ]

  if (strongPassword) {
    validations.push(
      validateOneUppercaseCharacter(value),
      validateOneSpecialCharacter(value)
    )
  }

  return validations.every((validation) => validation)
}
